var map = {
	"./en/btn_gift_1.png": "RLed",
	"./es/btn_gift_1.png": "kBUR",
	"./pt/btn_gift_1.png": "ZKOR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0kkk";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/btn_gift_1\.png$
// module id = 0kkk
// module chunks = 0